import React from "react";
import { connect } from "react-redux";
import { Splide, SplideSlide } from '@splidejs/react-splide';
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

const mapStateToProps = state => {
    return {
        pluginPath: state.appSettings.pluginPath
    }
}

class Image extends React.Component {
    render() {
        var sliderChildren = null;
        var sliderOptions = {
            type: "loop",
            perPage: 3,
            perMove: 1,
            gap: "10px",
            pagination: false,
            breakpoints: {
                768: {
                    perPage: 1,
                    gap: "0",
                    pagination: true,
                }
            }
        }

        // Merge mainImage with imageGallery
        var mergedImageGallery = [this.props.mainImage].concat(this.props.galleryImages.map(image => {
            return image.mediaItemUrl;
        }));
        mergedImageGallery = mergedImageGallery.filter((image, key) => {
            return (typeof image === "string" && mergedImageGallery.indexOf(image) === key);
        });
        
        // Has no image => DISPLAY PLACEHOLDER
        if (mergedImageGallery.length === 0) {
            sliderChildren = [0, 1, 2].map(key => {
                return <SplideSlide key={key}>
                    <div className="image-placeholder">
                        <img className="placeholder-icon" src={this.props.pluginPath + "/assets/LoadingPlaceholder.png"} />
                    </div>
                </SplideSlide>
            });

        // Has one image => DISPLAY ONE IMAGE
        } else if (mergedImageGallery.length === 1) {
            return <div className="image-slider-wrap single-image">
                <img src={mergedImageGallery[0]} />
            </div>

        // Has many images => SHOW SLIDESHOW
        } else {
            sliderChildren = mergedImageGallery.map((item, key) => {
                return <SplideSlide key={key}>
                    <img src={item} />
                </SplideSlide>;
            });
        }

        return <div className="image-slider-wrap">
            <Splide className="image-slider" options={sliderOptions}>
                {sliderChildren}
            </Splide>

            {this.props.children}
        </div>
    }
}

export default connect(mapStateToProps)(Image);